import React from 'react';
import "./QualityControl.css";
import { useTranslation } from 'react-i18next';

function QualityControl() {

  const { t } = useTranslation();

  return (
    <div className='qualitycontrol-container'>
      <div className="qualitycontrol-content">

        <div className='qualitycontrol-header'>
          <h3>{t('nav_quality_qualitycontrol')}</h3>
        </div>
        <div className='pro-text-promotion'>

          <li>{t('quality-control-p-one')}</li>
          <li>{t('quality-control-p-two')}</li>
          <li>{t('quality-control-p-three')}</li>

        </div>

        <div className='qualitycontrol-header-bottom'>

        </div>

      </div>
    </div>
  )
}

export default QualityControl